;(function (angular, $, window) {
    'use strict';
    angular.module('digitickApp').controller('BlockHeaderCtrl', ['$scope', '$element', '$rootScope', 'ShoppingCartFactory', 'AuthService', function($scope, $element, $rootScope, ShoppingCartFactory, AuthService) {
        $scope.searchValue = null;
        $rootScope.headerBigShow = (typeof HEADER_TINY_FORCE === 'undefined' || !HEADER_TINY_FORCE)?true:false;
        $rootScope.headerTinyHeight = 0;

        $scope.AuthService = AuthService;

        $scope.clearInput = function(){
            $scope.searchValue = null;
        };

        $scope.ShoppingCartFactory = ShoppingCartFactory;

        //-----------------------------------
        // TRACKING
        //-----------------------------------
        var tackingUserSearchEnginequery = '';
        window.localLinkClicked = false;
        $scope.$watch('searchValue', function(newValue, oldValue){
            if (newValue === oldValue) {
                return false;
            }
            if($scope.searchValue != null && $scope.searchValue != ''){
                tackingUserSearchEnginequery = $scope.searchValue;
            }
        });

        $('a').on('click', function() {
            var url = $(this).attr("href");
            window.localLinkClicked = true;
        });

        $(window).on("beforeunload", function() {
            if(!window.localLinkClicked && tackingUserSearchEnginequery != ''){
                dataLayer.push({
                    'event' : 'GAEvent',
                    'eventCategory' : 'Abandon',
                    'eventAction' : 'autocomplete',
                    'eventLabel' : tackingUserSearchEnginequery
                });
            }
        })
        //-----------------------------------
        // END TRACKING
        //-----------------------------------

        $scope.$watch(function() { return $rootScope.headerBigShow }, function(newValue, oldValue) {
            if (newValue === oldValue) {
                return false;
            }

            var headerBigInput = $element.find('.header-big [sf-typeahead]');
            var headerTinyInput = $element.find('.header-tiny [sf-typeahead]');

            if(headerTinyInput.is( ":focus" )){
                setTimeout(function() {
                    headerTinyInput.typeahead('close');
                    headerBigInput.focus().typeahead('val', $scope.searchValue).typeahead('open');
                }, 300);
            }else if(headerBigInput.is( ":focus" )){
                setTimeout(function() {
                    headerBigInput.typeahead('open');
                    headerTinyInput.focus().typeahead('val', $scope.searchValue).typeahead('open');
                }, 300);
            }
        });

    }]);
})(angular, jQuery, window);
(function (angular, $, window) {
    'use strict';
    angular.module('digitickApp').directive("scrollHeader", ['$window', '$rootScope', function($window, $rootScope) {
        return {
            controller: function ($scope) {
                var headerBig = angular.element('.header-big');
                var headerTiny = angular.element('.header-tiny');

                var getHeaderTinyHeight = function(){
                    var headerTinyHeight = headerTiny.attr('style', 'display: block !important').height();
                    headerTiny.attr('style', '');
                    return headerTinyHeight;
                };
                var getHeaderBigHeight = function(){
                    var headerBigHeight = headerBig.attr('style', 'display: block !important').height();
                    headerBig.attr('style', '');
                    return headerBigHeight;
                };
                var getHeaderBigOffset = function(){
                    var headerTinyOffset = headerBig.attr('style', 'display: block !important').offset();
                    headerBig.attr('style', '');
                    return headerTinyOffset;
                };
                $rootScope.headerBigHeight = getHeaderBigHeight();
                $rootScope.headerTinyHeight = getHeaderTinyHeight();
                $rootScope.headerTinyOffset = getHeaderBigOffset();

                if(typeof HEADER_TINY_FORCE === 'undefined' || HEADER_TINY_FORCE == false){
                    angular.element($window).on("scroll", function () {
                        var headerBigShow;
                        if (this.pageYOffset >= $rootScope.headerTinyOffset.top + $rootScope.headerBigHeight - $rootScope.headerTinyHeight) {
                            headerBigShow = false;
                        } else {
                            headerBigShow = true;
                        }
                        if(headerBigShow != $rootScope.headerBigShow){
                            $scope.$apply(function(){
                                $rootScope.headerBigShow = headerBigShow;
                            });
                            setTimeout(function(){ $(window).trigger('scroll'); }, 200);
                        }
                    });
                }else{
                    $rootScope.headerTinyHeight = getHeaderTinyHeight();
                    $('#wrapper').css('top', $rootScope.headerTinyHeight + 'px')
                }


                angular.element($window).on("resize", function () {
                    $scope.$apply(function(){
                        $rootScope.headerBigHeight = getHeaderBigHeight();
                        $rootScope.headerTinyHeight = getHeaderTinyHeight();
                        $rootScope.headerTinyOffset = getHeaderBigOffset();
                    });
                });
            }
        }
    }]);
})(angular, jQuery, window);